import { render, staticRenderFns } from "./SalesOrderBase.vue?vue&type=template&id=5d93733e&scoped=true"
import script from "./SalesOrderBase.vue?vue&type=script&lang=js"
export * from "./SalesOrderBase.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderBase.vue?vue&type=style&index=0&id=5d93733e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93733e",
  null
  
)

export default component.exports